import { AddAssignmentUserSurveyDocument } from '@/store/v2';
import { FetchResult, useMutation } from '@apollo/client';

import { AssignmentUserSurveyInput, AssignmentUserSurveyResult } from '@/store/learningLoops/types';

export const useAddAssignmentUserSurvey = (): {
  addAssignmentUserSurvey: (
    input: AssignmentUserSurveyInput,
  ) => Promise<FetchResult<{ addAssignmentUserSurvey: AssignmentUserSurveyResult }>>;
  loading: boolean;
  error: boolean;
} => {
  const [addAssignmentUserSurvey, { loading, error }] = useMutation<{
    addAssignmentUserSurvey: AssignmentUserSurveyResult;
  }>(AddAssignmentUserSurveyDocument);

  return {
    addAssignmentUserSurvey: async (input: AssignmentUserSurveyInput) =>
      addAssignmentUserSurvey({
        variables: { input },
      }),
    loading,
    error: !!error,
  };
};
